import React from 'react'

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Divider,
  Typography,
  Button,
} from '@material-ui/core'
import { isNull } from 'lodash'

import * as service from 'service'
import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

const DialogChangeStatus = ({
  active,
  committeeId,
  committeeUserId = null,
  open,
  setOpen = () => {},
  onEvent = () => {},
}) => {
  const snackbar = useSnackbar()
  const isCommittee = isNull(committeeUserId)

  const changeStatus = async () => {
    if (isCommittee) {
      try {
        await service.dponet.committees.changeStatus({ committeeId })
        snackbar.open({
          message: active
            ? 'Comitê inativado com sucesso!'
            : 'Comitê ativado com sucesso!',
          variant: 'success',
        })
        setOpen(false)
        onEvent()
      } catch (error) {
        snackbar.open({
          message: helpers.formatters.errorMessage(
            error.response && error.response.data && error.response.data.error,
          ),
          variant: 'error',
        })
        setOpen(false)
      }
    } else {
      try {
        await service.dponet.committeeUsers.changeStatus({
          committeeId,
          committeeUserId,
        })
        snackbar.open({
          message: active
            ? 'Usuário inativado do comitê com sucesso!'
            : 'Usuário ativado no comitê com sucesso!',
          variant: 'success',
        })
        setOpen(false)
        onEvent()
      } catch (error) {
        snackbar.open({
          message: helpers.formatters.errorMessage(
            error.response && error.response.data && error.response.data.error,
          ),
          variant: 'error',
        })
        setOpen(false)
      }
    }
  }

  return (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>
        <Box>
          <Typography variant="h4">
            {active ? 'Inativar' : 'Ativar'} comitê
          </Typography>
        </Box>
      </DialogTitle>
      <Divider />
      <Box mb={1}>
        <DialogContent>
          <Box>
            <Typography>
              Tem certeza que deseja {active ? 'inativar' : 'ativar'} este
              {isCommittee ? ' ' : ' usuário de '}comitê?
            </Typography>
          </Box>
        </DialogContent>
      </Box>
      <Divider />
      <DialogActions p={2}>
        <Box pl={2} pr={1}>
          <Button
            type="button"
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Cancelar
          </Button>
        </Box>
        <Button
          variant="contained"
          type="submit"
          color="primary"
          onClick={changeStatus}
        >
          Continuar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DialogChangeStatus
